module.exports = "/_next/static/images/headphones-monotone-6a70d135a8303b2c487474250b549269.svg";